// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import componentBase from '../../../../src/lib/component-base';
import { dateFormatString } from '../../../../src/lib/date-time-format';
import FSFlatButton from '../../../../src/components/lib/FSFlatButton';
// redux
import { getDataExportById, createDataExportEvent } from '../../redux/actions';
import { startSpinner, endSpinner } from '../../../Account/redux/actions';
import { isChargedAndReadyState } from '../../redux/selectors';
// child components
import ExportDataDescription from '../shared/ExportDataDescription/ExportDataDescription';
import MetadataChart from '../shared/MetadataChart/MetadataChart';
import DataExportQueryHistory from './children/DataExportQueryHistory/DataExportQueryHistory';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
// helpers
import { handlePollingForCookie } from '../lib/helpers/handlePollingForCookie';
import reportException from '../../../../shared/lib/report-exception';
import { DataExports as DataExportsAds } from '../ads';

// constants
import { mapCategories } from '../home/constants';

@connect(state => ({
  dataExportQuoteCurrentEstimateError: state.DataExports.dataExportQuoteError,
  dataExportQuoteCurrentEstimate: state.DataExports.dataExportQuoteCurrentEstimate,
  timers: state.DataExports.timers,
  user: state.Account.user,
}))
@componentBase('DataExportsHistoryDetail')
export default class DataExportsHistoryDetail extends Component {
  static propTypes = {
    dataExportQuoteCurrentEstimate: PropTypes.object,
    dataExportQuoteCurrentEstimateError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    dispatch: PropTypes.func,
    location: PropTypes.object,
    match: PropTypes.object,
    name: PropTypes.string,
    route: PropTypes.object,
    timers: PropTypes.object,
    user: PropTypes.object,
  }

  componentWillMount() {
    this.handlePollingForCookie = handlePollingForCookie.bind(this);
    this.downloadAsCSV = this.downloadAsCSV.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;

    const { id } = match && match.params;

    if (id) {
      dispatch(getDataExportById(id));
    }
  }

  setCookieTimerRef = (newTimer) => {
    this.cookieUpdateTimer = newTimer();
  }

  cookieUpdateTimer = null;

  killCookieUpdateTimer = (cookieName) => {
    if (this.cookieUpdateTimer) {
      clearTimeout(this.cookieUpdateTimer);
      this.cookieUpdateTimer = null;
    }
    // cleanup by deleting cookie that corresponds to the download
    this.deleteCookie(cookieName);
    // done, so stop the spinner

    this.props.dispatch(endSpinner());
  }

  deleteCookie = (cookieName, path) => {
    const namePart = `${cookieName || ''}=""`;
    const pathPart = `path=${path || '/'}`;
    // set cookie to being expired a long time ago;
    const expiration = 'expires=Thu, 01 Jan 1970 00:00:01 GMT';
    const newCookie = [namePart, pathPart, expiration].join(';');
    try {
      document.cookie = newCookie;
    } catch (e) {
      this.logErrors('could not delete cookie', e);
    }
  }

  quoteData = () => {
    const { dataExportQuoteCurrentEstimate } = this.props;
    if (dataExportQuoteCurrentEstimate) {
      return dataExportQuoteCurrentEstimate;
    }
    return null;
  }

  paymentStatePast = () => {
    const data = this.quoteData();
    const status = data && data.status;
    if (status) {
      return isChargedAndReadyState(status);
    }
    return false;
  }

  headerCategoryText = () => {
    let text = '';
    if (this.quoteData()) {
      const { type } = this.quoteData();
      text = mapCategories(type);
    }
    return text;
  }

  createdAt = () => {
    let text = '';
    if (this.quoteData()) {
      const { created_at: createdAt } = this.quoteData();
      text = moment.utc(createdAt).format(dateFormatString(this.context.currentUser));
    }
    return text;
  }

  logErrors = (errorString = '', errorObject) => (errorString ?
    reportException({ message: errorString }, this.props.location && this.props.location.pathname) :
    reportException(errorObject, this.props.location && this.props.location.pathname));

  createDataExportEvent = (dataExportEventType, id) => {
    this.props.dispatch(createDataExportEvent(dataExportEventType, id));
  }

  downloadAsCSV = (id) => {
    // just need id of a data export
    this.props.dispatch(startSpinner());

    const cookieName = new Date().getTime(); // ex: 1493140063584

    const tabName = 'data_export.csv';
    try {
      const tabUrl = `${window.location && window.location.origin}/v2/api/data-exports/download?id=${id}&cookie=${cookieName}&location=history/${id}`;
      // TODO:
      // /v2 appended for need to remove in the future when /v2 is no longer required.
      //

      /*
      const tabUrl = `${window.location && window.location.origin}
      /api/data-exports/download?id=3&cookie=${cookieName}`;
      */
      const tab = window.open(tabUrl, tabName);

      this.handlePollingForCookie(cookieName, id, tab);
      // handlePollingForCookie(this, cookieName, 3, tab);
    } catch (e) {
      this.logErrors('unable to open new tab to download csv', e);
    }
  }

  render() {
    // this.logger('props: ', this.props);
    const { dataExportQuoteCurrentEstimate } = this.props;
    const subscriptionActive = this.props.user && this.props.user.subscriptionActive;
    const status = dataExportQuoteCurrentEstimate && dataExportQuoteCurrentEstimate.status;

    const adUnits = {
      mobileAd: DataExportsAds.topMobile,
      desktopAd: DataExportsAds.top,
    };

    return (
      <div>
        <BannerAd
          topAd
          {...adUnits}
          subscriptionActive={subscriptionActive}
          style={{ marginBottom: '-10px' }}
        />
        <header
          className='data-export-recap-header row'
        >
          <div
            className='col-sm-12 col-md-8'
          >
            <h3>
              {this.headerCategoryText()} Data Export Recap
            </h3>
            <p>
              Export created on <time>{this.createdAt()}</time>
            </p>
          </div>
          <div
            className='col-sm-12 col-md-4'
          >
            <FSFlatButton
              containerElement={(<Link to='/data-exports/home' />)}
              label='GO BACK TO DATA EXPORTS'
              style={FSFlatButton.style({
 display: 'block', width: '235px', height: '45px', fontSize: '20px', lineHeight: '42px',
})}
              backgroundColor='rgb(254, 169, 0)'
            />
          </div>
        </header>
        <DataExportQueryHistory
          quoteData={this.quoteData()}
        />
        <ExportDataDescription
          dispatch={this.props.dispatch}
          downloadAsCSV={this.downloadAsCSV}
          quoteData={this.quoteData()}
          isDataExportHistory
          paymentStatePast={this.paymentStatePast()}
          status={status}
        />
        <MetadataChart
          quoteData={this.quoteData()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/DataExportsHistoryDetail/DataExportsHistoryContainer.js